import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { ToggleRegs } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/toggleregs`,
    response: {} as ToggleRegs.Get.TogglesRegistered,
    method: HTTP_METHODS.GET,
  },
  [HTTP_METHODS.PUT]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/toggleregs`,
    request: {} as ToggleRegs.Put.Toggles,
    method: HTTP_METHODS.PUT,
  },
};
